module.exports = __webpack_public_path__ + "static/media/Create_limited_time_offers2.02cdb7a5.svg";